module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0086.jpg?v=0521b1c6";